import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef, useRef, useId, useCallback } from 'react';
import classNames from 'classnames';
import { Card } from '../Card/Card.es.js';
import { Icon } from '../Icon/Icon.es.js';

const SelectCard = /*#__PURE__*/ forwardRef(({ id: propId, label, type, onChange, value, name, checked, warning, className, children, disabled, alignCheck = 'center', hideCheck = false, ...rest }, ref)=>{
    /**
     * Ref used on the input.
     */ const input = useRef(null);
    const defaultId = useId();
    const id = propId ?? defaultId;
    /**
     * Handle clicking of the <div> (making the entire card clickable).
     */ const handleCardClick = useCallback(()=>{
        if (input.current) {
            input.current.focus();
            input.current.click();
        }
    }, []);
    const handleChange = useCallback((e)=>{
        onChange?.(e);
    }, [
        onChange
    ]);
    const setRef = useCallback((e)=>{
        if (e != null) {
            input.current = e;
        }
        if (typeof ref === 'function') {
            ref(e);
        } else if (ref != null) {
            ref.current = e;
        }
    }, [
        ref
    ]);
    return jsxs("div", {
        className: classNames('cb-select-card', type, className),
        children: [
            jsx("label", {
                className: "sr-only",
                htmlFor: id,
                children: label
            }),
            jsx(Card, {
                className: classNames('card', alignCheck),
                "data-testid": `select-card-${id}`,
                disabled: disabled,
                id: `${id}-content`,
                onClick: handleCardClick,
                selected: checked,
                warning: warning,
                clickable: true,
                ...rest,
                children: jsxs(Card.Content, {
                    className: "card-content",
                    children: [
                        jsx("div", {
                            children: children
                        }),
                        jsx("input", {
                            ref: setRef,
                            "aria-details": `${id}-content`,
                            checked: checked,
                            disabled: disabled,
                            id: id,
                            name: name,
                            onChange: handleChange,
                            type: type,
                            value: value
                        }),
                        !hideCheck && jsx(Icon, {
                            className: "check-icon",
                            name: "CheckCircleSolid"
                        })
                    ]
                })
            })
        ]
    });
});
SelectCard.displayName = 'SelectCard';

export { SelectCard, SelectCard as default };
//# sourceMappingURL=SelectCard.es.js.map
